import url from '../../utils/url.js'

export default {
  data () {
    return {
      freezeAllEvents: false
    }
  },
  methods: {
    unFreezeAll () {
      console.log('formModal unFreezeAll')
      this.freezeAllEvents = false
      this.$bar.finish()
    },
    freezeAll () {
      console.log('formModal freezeAll')
      this.freezeAllEvents = true
      this.$bar.start()
    },
    redirectToPrev () {
      if (this.$route.query && this.$route.query.prevRoute) {
        // disable reload data (in tables)
        let redirectTo = JSON.parse(this.$route.query.prevRoute)
        // disable reload data
        this.$store.commit('skipAsyncData', {
          name: redirectTo.name,
          value: true
        })
        this.$router.push(redirectTo, () => {
          // after route open, enable async
          this.$store.commit('skipAsyncData', {
            name: redirectTo.name,
            value: false
          })
        })
      } else if (this.$route.matched && this.$route.matched[1]) {
        let redirectRoute = url.getRoute(this.$route.matched[1])
        this.$router.push(redirectRoute)
      }
    }
  }
}
